/**
 * Direction/placement string constants used across the new car layout.
 * Kept in a dependency-free module so both constants.ts and the types file
 * can reference them without a circular import.
 */

/** Row a seat group sits in / where its group-number label is placed */
export const GROUP_DIRECTION = {
  Top: 'top',
  Bottom: 'bottom'
} as const;

/** Which side a seat's back band is drawn on */
export const SEAT_SIDE = {
  Left: 'left',
  Right: 'right'
} as const;

/** Corner of the open deck where the entrance label is drawn */
export const ENTRANCE = {
  TopLeft: 'topLeft',
  TopRight: 'topRight',
  BottomLeft: 'bottomLeft',
  BottomRight: 'bottomRight'
} as const;

/**
 * Physical zone kinds. Display-only blocks at the car ends; they do not take
 * part in arrangementType assignment.
 */
export const PHYSICAL_ZONE_KIND = {
  DriverRoom: 'driverRoom', // 運転室
  SpecialRoom: 'specialRoom', // 特別室
  OpenDeck: 'openDeck', // オープンデッキ（立見）
  ConductorRoom: 'conductorRoom', // 車掌室
  TractionCar: 'tractionCar' // 牽引車
} as const;

/** Seat-group row / group-number placement */
export type GroupDirection =
  (typeof GROUP_DIRECTION)[keyof typeof GROUP_DIRECTION];

/** Open-deck entrance corner */
export type Entrance = (typeof ENTRANCE)[keyof typeof ENTRANCE];

/** Physical zone kind */
export type PhysicalZoneKind =
  (typeof PHYSICAL_ZONE_KIND)[keyof typeof PHYSICAL_ZONE_KIND];
